export default "__VITE_ASSET__C5KHTNNH__"